import clsx from "clsx";

import { makeStyles } from "@material-ui/core/styles";
import { Box, Container, Grid, Paper } from "@material-ui/core";

import Stock from "../Stock/Stock";
import SellProduct from "../SellProduct/SellProduct";
import Manufacturer from "../Manufacturer/Manufacturer";

import salesPanelStyle from "./SalesPanelStyle";

const useStyles = makeStyles((theme) => salesPanelStyle(theme));

const SalesPanel = () => {
    const classes = useStyles();
    const fixedHeightPaper = clsx(classes.paper, classes.fixedHeight);

    return (
        <main className={classes.content}>
            <div className={classes.appBarSpacer} />
            <Container maxWidth="lg" className={classes.container}>
                <Grid container spacing={3}>
                    <Grid item xs={12} md={8} lg={9}>
                        <SellProduct />
                    </Grid>
                    <Grid item xs={12} md={4} lg={3}>
                        <Paper
                            className={clsx(
                                fixedHeightPaper,
                                classes.containerManufacturer
                            )}
                        >
                            <Manufacturer />
                        </Paper>
                    </Grid>
                    <Grid item xs={12}>
                        <Stock />
                    </Grid>
                </Grid>
                <Box pt={4}></Box>
            </Container>
        </main>
    );
};

export default SalesPanel;
